import React from "react";

import { getAppVersionLabel } from "../../../utils/appVersion";
import BackOfficeLogoMark from "./marks";
import { ACTIVE_BACK_OFFICE_LOGO_VARIANT, MARK_SIZES } from "./consts";
import { BackOfficeLogoProps } from "./types";
import { LogoRoot, WordMark, WordMarkMeta, WordMarkTitle, WordMarkVersion } from "./styles";

/** The app's logo: the active variant's mark, with the wordmark and build label beside it. */
const BackOfficeLogo = ({
  className,
  showWordmark = true,
  size = "nav",
  variant = ACTIVE_BACK_OFFICE_LOGO_VARIANT,
}: BackOfficeLogoProps) => {
  const versionLabel = getAppVersionLabel();

  return (
    <LogoRoot className={className} $size={size} aria-label="Back Office">
      <BackOfficeLogoMark variant={variant} size={MARK_SIZES[size]} aria-hidden="true" />
      {showWordmark && (
        <WordMark $size={size}>
          <WordMarkTitle $size={size}>Back Office</WordMarkTitle>
          <WordMarkMeta $size={size}>Assets View management</WordMarkMeta>
          {versionLabel && <WordMarkVersion $size={size}>{versionLabel}</WordMarkVersion>}
        </WordMark>
      )}
    </LogoRoot>
  );
};

export { default as BackOfficeLogoMark } from "./marks";
export { ACTIVE_BACK_OFFICE_LOGO_VARIANT, BACK_OFFICE_LOGO_VARIANTS } from "./consts";
export type { BackOfficeLogoVariant } from "./types";

export default BackOfficeLogo;
